export const actionTypes = {
  VERIFY_RESET_PASSWORD_TOKEN_REQUEST: 'VERIFY_TOKEN_REQUEST',
  VERIFY_RESET_PASSWORD_TOKEN_SUCCESS: 'VERIFY_TOKEN_SUCCESS',
  VERIFY_RESET_PASSWORD_TOKEN_FAILURE: 'VERIFY_TOKEN_FAILURE',

  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
};
